import { Children } from 'react';
import getElementName from './getElementName.js';
const groupByType = (children, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
types = [], rest = 'rest') => {
    const typeNames = types.map((type) => (typeof type === 'string' ? type : type.name));
    return Children.toArray(children).reduce((acc, child) => {
        const elementName = getElementName(child);
        const key = elementName !== null && typeNames.includes(elementName) ? elementName : rest;
        if (typeof acc[key] === 'undefined') {
            acc[key] = [];
        }
        acc[key] = [...acc[key], child];
        return acc;
    }, {});
};
export default groupByType;
//# sourceMappingURL=groupByType.js.map